export const assetRequests = state => state.portal.reports.assets;
export const credentialsRequests = state => state.portal.reports.credentials;
export const cateringRequests = state => state.portal.reports.catering;
export const isFetching = state => state.portal.reports.assets.fetching;
